module.exports = __webpack_public_path__ + "static/media/enisaWhite.7be7f610.png";